import React, { FC } from 'react';
import { ErrorAlert } from '../../../components';

export const ConsumerSchedulingPageNotFoundErrorAlert: FC = (): JSX.Element => (
  <ErrorAlert message="This page does not exist." description="Please fix the URL and try again." />
);
